import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checked-circle",
  "use": "svg_checked-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg_checked-circle\"><path d=\"M14.28 7.22a.748.748 0 0 1 0 1.06l-5.25 5.25a.748.748 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0ZM19.75 10A9.75 9.75 0 1 1 10 .25 9.76 9.76 0 0 1 19.75 10Zm-1.5 0A8.25 8.25 0 1 0 10 18.25 8.26 8.26 0 0 0 18.25 10Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol